module.exports = __webpack_public_path__ + "static/media/andre_camarinha.628b345d.jpg";